module.exports = __webpack_public_path__ + "static/img/price.d01e1d02.png";